import { UserDocument } from "../../models/UserDocument";
import { useEffect, useState } from "react";
import { DocumentItem } from "./DocumentItem";
import { getDocumentContents } from "./getDocumentContents";

interface Props {
  document: UserDocument;
  onClick?: (docSrc: string | undefined) => void;
  onDelete?: (docSrc: string | undefined) => void,
  onDownload?: () => void,
}

export const DocumentItemWrapper = ({
  document,
  onClick,
  onDelete,
  onDownload,
}: Props): JSX.Element => {
  const [documentSrc, setDocumentSrc] = useState<undefined | string>();
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    (async () => {
      if (!document?.id || !document?.version?.id) {
        return
      }
      if (document?.version?.cloudUrl) {
        setDocumentSrc(document.version.cloudUrl)
        setIsLoading(false)
      } else {
        const contents = await getDocumentContents(
          document.id,
          document.version.id,
          undefined,
          !!document.version?.thumbnailS3Key,
          Math.floor(Math.random() * 20), //Add jitter to help not-kill the server 
        )
        setDocumentSrc(contents)
        setIsLoading(false)
      }


    })()
  }, [document?.version?.id, document?.id])

  return <DocumentItem
    isLoading={isLoading}
    key={document.id + "_doc_" + documentSrc}
    document={document}
    documentSrc={documentSrc}
    onClick={() => onClick?.(documentSrc)}
    onDelete={() => onDelete?.(documentSrc)}
    onDownload={onDownload}
  />
};